import { request } from '@h3/request';
import { H3 } from '@h3/types';
import * as Api from './constant';

// 请求头
const headers = {
    'Content-Type': H3.Http.ContentType.FORM_URLENCODED,
};

/**
 * 触发自动化
 * @param schemaCode
 * @param actionCode
 * @param bizObjectIds
 * @param actionBelong
 * @param customParams
 * @returns
 */
export const triggerAutomation = (
    schemaCode: string,
    viewPageId: string | undefined,
    actionCode: string,
    bizObjectIds: string[],
    actionBelong: number, // 1 表单 2 列表
    customParams: Record<string, unknown>,
) => {
    const params = {
        schemaCode,
        viewPageId,
        actionCode,
        bizObjectIds,
        actionBelong,
        customParams,
    };
    return request<H3.Http.Response.H3Response>('/v1/bizdata/action/automation', {
        method: 'post',
        data: params,
    });
};

/**
 * 获取按钮执行自动化的自定义参数
 * @param schemaCode
 * @param actionCode
 * @returns
 */
export const getActionCustomParams = (
    schemaCode: string,
    viewPageId: string | undefined,
    actionCode: string,
    actionBelong = H3.SmartAction.ActionScene.Toolbar,
) => {
    const url = `/v1/automation/customparams?schemaCode=${schemaCode}&actionCode=${actionCode}&actionBelong=${actionBelong}${
        viewPageId ? `&viewPageId=${viewPageId}` : ''
    }`;
    return request<H3.Http.Response.H3Response<H3.Button.IDynamicControl[]>>(url, {
        method: 'get',
        data: {},
    });
};

// 根据应用编码获取根据表单分组的自动化数据
export const getAutomationByAppCode = (appCode: string) => {
    const params = {
        ActionName: 'LoadTriggersByAppCode',
        AppCode: appCode,
    };
    return request<H3.Http.Response.H3ResponseV2<H3.Automation.IGroupAutomationDataResponse>>('/Automatic/OnAction', {
        method: 'post',
        data: {
            PostData: JSON.stringify(params),
        },
        headers,
        requestType: 'form',
        disableBizError: true,
    });
};

/** 加载触发器 */
export const getAutomationTriggerList = (params: { schemaCode: string; type: number; state?: boolean }) =>
    request<H3.Http.Response.H3Response<H3.Automation.V3.IAutomationData[]>>(Api.GetAutomationTriggers, {
        method: H3.Http.MethodType.POST,
        data: params,
        disableBizError: true,
        camelCase: true,
    });

/** 根据ID获取触发器 */
export const getAutomationTriggerById = (params: { id: string }) =>
    request<H3.Http.Response.H3Response<H3.Automation.V3.IAutomationData>>(Api.GetAutomationTrigger, {
        method: H3.Http.MethodType.GET,
        params,
        camelCase: true,
    });

/** 许可检查 */
export const getAutomationLimit = () =>
    request<H3.Http.Response.H3Response<boolean>>(Api.GetAutomationLimit, {
        method: H3.Http.MethodType.GET,
    });
